import { useState } from "react";
import Button from "../../../components/button";
import PopUp from "../../../components/popUp";
import { useAppContext } from "../../../context/appContext";
import { getInstrument } from "../../../data/instrumentManager";
import { RawScoreData } from "../../../data/scoreData";
import { PieceDTO } from "../../../openapi-generated-client";
import { removeDoubleElements } from "../../../utils/arrayUtils";
import { delay } from "../../../utils/functionUtils";
import PieceUploadingPopUp from "./pieceUploadingPopUp";
import { allDurations, allPrices } from "./steps/editPieceGeneral";

interface PieceSummaryPopUpProps {
    piece: PieceDTO;
    scores: RawScoreData[];
    onPublish: () => Promise<string>;
}

export default function PieceSummaryPopUp(props: PieceSummaryPopUpProps) {

    const { userData } = useAppContext();

    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);

    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);

    if(uploading) {
        return <PieceUploadingPopUp width={width} height={height} msg={error && error.length > 0 ? error : 
            userData?.artist?.verified ? "" : "Your piece still needs to get confirmed by us to be publically availible. You will be notified."
        } success={error == undefined ? undefined : error == ""}/>;
    }

    return <PopUp setWidth={setWidth} setHeight={setHeight} className="big" title="Piece Summary">
        <div className="columns">
            <div className="column left">
                <div className="grid-element">
                    <h4>Scores</h4>
                    {props.piece.externalScoreLink != undefined ? <p>External Link Provided</p> : <p>{props.scores.length} File{props.scores.length > 1 ? "s" : ""}</p>}
                </div>
                <div className="grid-element">
                    <h4>Title</h4>
                    <p>{props.piece.title}</p>
                </div>
                <div className="grid-element">
                    <h4>Year</h4>
                    <p>{props.piece.year}</p>
                </div>
                <div className="grid-element">
                    <h4>Type</h4>
                    <p>{props.piece.original ? "Original" : "Transcription"}</p>
                </div>
                <div className="grid-element">
                    <h4>Length</h4>
                    <p>{allDurations[props.piece.duration!]}</p>
                </div>
                <div className="grid-element">
                    <h4>Price</h4>
                    <p>{allPrices[props.piece.price!]}</p>
                </div>

            </div>
            <div className="column right">
                {props.piece.movements && props.piece.movements.length > 0 ? <div className="grid-element">
                    <h4>Movements</h4>
                    {props.piece.movements.map(e => {
                        return <p>{e}</p>
                    })}
                </div> : <></>}
                {
                    props.piece.orchestralInstruments && props.piece.orchestralInstruments.length > 0 ? <>
                    
                        <div className="grid-element">
                            <h4>Solist Instruments</h4>
                            {removeDoubleElements(props.piece.instruments!).map(e => {
                                return <p>{e.amount + " "}{getInstrument(e.instrument)?.name}</p>
                            })}
                        </div>
                        <div className="grid-element">
                            <h4>Orchestral Instruments</h4>
                            {removeDoubleElements(props.piece.orchestralInstruments!).map(e => {
                                return <p>{e.amount + " "}{getInstrument(e.instrument)?.name}</p>
                            })}
                        </div>
                    </> : 
                <div className="grid-element">
                    <h4>Instruments</h4>
                    {removeDoubleElements(props.piece.instruments!).map(e => {
                        return <p>{e.amount + " "}{getInstrument(e.instrument)?.name}</p>
                    })}
                </div>
                }
                {props.piece.original == false ? <div className="grid-element">
                    <h4>Transcription Information</h4>
                    <p>{props.piece.transcriptionInfo!.name}</p>
                    <p>{props.piece.transcriptionInfo!.realYear}</p>
                    
                </div> : <></>}
                <div className="grid-element">
                    <h4>Contributors</h4>
                    {props.piece.contributors!.map(e => {
                        return <p>{e.name}</p>
                    })}
                    {props.piece.contributors!.length == 0 ? <p>None</p> : <></>}
                </div>
                <div className="grid-element">
                    <h4>Performances</h4>
                    {props.piece.performances!.map(e => {
                        return <p>{e.performerName ? e.performerName : "no performer name"}</p>
                    })}
                    {props.piece.performances!.length == 0 ? <p>None</p> : <></>}

                </div>

            </div>
        </div>
        <Button extraPadding thin onClick={async () => {
            setUploading(true);
            await delay(1500);
            setError(await props.onPublish());
        }
        }>Publish</Button>
    </PopUp>

}